import { useContext, useState } from "react";
import { ReactComponent as Person } from "../../../assets/img/icon/person_black_24dp.svg";
import { CATEGORY } from "../../../config/constant";
import { getDateFormat } from "../../../helpers/helper";
import { GlobalContext } from "../../contexts/globalContext";
import CardDashboard from "../../ui/atoms/CardDashboard/CardDashboard";
import PageTitle from "../../ui/atoms/PageTitle/PageTitle";
import ModalUserData from "../../ui/organisms/ModalUserData/ModalUserData";
import ModalUserPassword from "../../ui/organisms/ModalUserPassword/ModalUserPassword";
import ModalUserProfile from "../../ui/organisms/ModalUserProfile/ModalUserProfile";

const Profile = () => {
  const [sharedState, dispatch] = useContext(GlobalContext);
  const handleCloseModal = () => {
    setModal(null);
  };
  const { user } = sharedState;
  const [modal, setModal] = useState(null);

  const handleChange = (e) => {};
  return (
    <>
      <ModalUserProfile
        show={modal === "profile"}
        handleClose={handleCloseModal}
      />
      <ModalUserPassword
        show={modal === "password"}
        handleClose={handleCloseModal}
      />
      <ModalUserData show={modal === "data"} handleClose={handleCloseModal} />

      <div className="mt-2 lg:mt-6">
        <PageTitle
          title="Halaman Profil"
          description="Dapatkan informasi akun dan profil pengguna respinos."
          icon={
            <Person className="w-10 sm:w-12 lg:w-16 h-10 sm:h-12 lg:h-16 fill-current text-white" />
          }
        />

        <div className="mt-12 md:mt-16">
          <CardDashboard
            icon={<Person fill={"#fafafa"} className="w-5 h-5" />}
            title="Profil Pengguna"
            className="pb-5"
          >
            <div>
              <div className="flex justify-end space-x-2">
                <div
                  className="text-sm cursor-pointer hover:underline"
                  onClick={() => setModal("profile")}
                >
                  Ubah Profil
                </div>
                <div
                  className="text-sm cursor-pointer hover:underline"
                  onClick={() => setModal("password")}
                >
                  Ubah Password
                </div>
              </div>
              <div className="mt-1 flex flex-col xl:flex-row space-x-0 xl:space-x-5 space-y-3 xl:space-y-0">
                <div className="w-full xl:w-80 flex-shrink-0">
                  <div className="flex items-center justify-center xl:justify-start">
                    <div className="w-32 flex-shrink-0">
                      <div
                        style={{
                          backgroundImage: `url("${user.profile.avatar}")`,
                        }}
                        className="w-24 h-24 rounded-full bg-center bg-cover mx-auto relative"
                      />
                    </div>
                    <div>
                      <div className="text-xl font-semibold">{user.name}</div>
                      <div className="text-gray-600 text-opacity-50">
                        {user.email}
                      </div>
                    </div>
                  </div>
                  <div className="text-sm mt-2 mx-auto max-w-lg text-center xl:text-left">
                    {user.profile.description || "There is no description yet"}
                  </div>
                </div>
                <div className="w-full text-sm md:text-base">
                  <div className="mt-1 md:mt-3 grid grid-cols-12 items-center">
                    <div className="col-span-12 sm:col-span-3 xl:col-span-4">
                      Kategori
                    </div>
                    <div className="col-span-12 sm:col-span-9 xl:col-span-8 w-full bg-primary bg-opacity-20 text-gray-700 text-opacity-70 px-2 md:px-3 py-1 rounded-lg">
                      {user.role ? CATEGORY[user.role] : ""}
                    </div>
                  </div>

                  <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
                    <div className="col-span-12 sm:col-span-3 xl:col-span-4">
                      Tempat Praktek
                    </div>
                    <div className="col-span-12 sm:col-span-9 xl:col-span-8 w-full bg-primary bg-opacity-20 text-gray-700 text-opacity-70 px-2 md:px-3 py-1 rounded-lg">
                      {user.profile.workingPlace || ""}
                    </div>
                  </div>
                  <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
                    <div className="col-span-12 sm:col-span-3 xl:col-span-4">
                      Nomor STR
                    </div>
                    <div
                      className={
                        "col-span-12 sm:col-span-9 xl:col-span-8 w-full bg-primary bg-opacity-20 text-gray-700 text-opacity-70 px-2 md:px-3 py-1 rounded-lg "
                      }
                    >
                      {user.profile.strNumber || ""}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CardDashboard>
        </div>
        <div className="mt-10">
          <CardDashboard title="Data Pengguna" className="pb-5">
            <div className="flex justify-end space-x-2">
              <div
                className="text-sm cursor-pointer"
                onClick={() => setModal("data")}
              >
                Ubah Data
              </div>
            </div>
            <div className="mt-6">
              <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
                <div className="col-span-12 sm:col-span-3">Jenis Kelamin</div>
                <div
                  className={
                    "col-span-12 sm:col-span-9 w-full bg-primary bg-opacity-20 text-gray-700 text-opacity-70 px-2 md:px-3 py-1 rounded-lg "
                  }
                >
                  {user.profile.isMale != undefined
                    ? user.profile.isMale !== true
                      ? "Perempuan"
                      : "Laki-laki"
                    : "-"}
                </div>
              </div>
              <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
                <div className="col-span-12 sm:col-span-3">Tanggal Lahir</div>
                <input
                  type="date"
                  placeholder="yyyy-mm-dd"
                  className={
                    "col-span-12 sm:col-span-9 w-full bg-primary bg-opacity-20 text-gray-700 text-opacity-70 px-2 md:px-3 py-1 rounded-lg focus:outline-none "
                  }
                  value={
                    user.profile.dateOfBirth
                      ? `${getDateFormat(user.profile.dateOfBirth)}`
                      : ""
                  }
                  onChange={handleChange}
                  disabled={true}
                />
              </div>
              <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
                <div className="col-span-12 sm:col-span-3">Berat Badan</div>
                <div
                  className={
                    "col-span-12 sm:col-span-9 w-full bg-primary bg-opacity-20 text-gray-700 text-opacity-70 px-2 md:px-3 py-1 rounded-lg"
                  }
                >
                  {user.profile.weight ? `${user.profile.weight} kg` : "-"}
                </div>
              </div>
              <div className="mt-3 md:mt-5 grid grid-cols-12 items-center">
                <div className="col-span-12 sm:col-span-3">Tinggi Badan</div>
                <div
                  className={
                    "col-span-12 sm:col-span-9 w-full bg-primary bg-opacity-20 text-gray-700 text-opacity-70 px-2 md:px-3 py-1 rounded-lg"
                  }
                >
                  {user.profile.height ? `${user.profile.height} cm` : "-"}
                </div>
              </div>
            </div>
          </CardDashboard>
        </div>
      </div>
    </>
  );
};

export default Profile;
